import isAfter from 'date-fns/isAfter'
import addDays from 'date-fns/addDays'
import { removeTime } from '@/utils/date'

function getMessage(field, args) {
  if (args === void 0) args = [0]
  const daysBeforeCover = Number(args[0])
  if (daysBeforeCover === 0) {
    return `The ${field} cannot be later than the date of application.`
  } else if (daysBeforeCover > 0) {
    return `The ${field} cannot be later than ${daysBeforeCover} day(s) from the date of application.`
  }
}

function validate(value, args) {
  if (value) {
    if (args === void 0) args = []
    var daysBeforeCover = args[0]
    if (daysBeforeCover !== undefined && daysBeforeCover !== 'undefined') {
      let maxDate = removeTime(new Date())
      daysBeforeCover = Number(daysBeforeCover)
      maxDate = addDays(maxDate, daysBeforeCover)

      const startDate = removeTime(value)
      // if (isAfter(startDate, maxDate)) return false
      // else return true
      return !(isAfter(startDate, maxDate))
    } else return true
  } else return true
}

export default {
  getMessage,
  validate
}
